import React, { useState } from 'react';
import TopicSelection from './components/TopicSelection';
import RiskGenerator from './components/RiskGenerator';
import ChatWindow from './components/ChatWindow';
import BackToTopics from './components/BackToTopics';
const App = () => {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [appState, setAppState] = useState('topicSelection');
  const [risk, setRisk] = useState('');

  const handleTopicSelect = (topic) => {
	console.log('Topic selected: ' + topic);
	//scroll to anchor gpt-anchor
	var anchorElement = document.getElementById('gpt-anchor');
	if(anchorElement !== null){
    	anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

    setSelectedTopic(topic);
	setAppState('riskGenerator');
  };

  const handleGetTask = (risk) => {
	console.log('Getting task...');
	setRisk(risk);
    // You will need to implement this function to handle the transition to getting a task
	setAppState('ChatWindow');
  };

  return (
    <div className="GPTApp">
		<div className="container text-center d-flex flex-column flex-lg-row align-items-center">
			{appState === 'topicSelection' && (
				<TopicSelection onTopicSelect={handleTopicSelect} />
			)}
			{appState === 'riskGenerator' && (
				<>
					<BackToTopics onBackToTopics={() => setAppState('topicSelection')} />
					<RiskGenerator selectedTopic={selectedTopic} onGetTask={handleGetTask} />
				</>
			)}
			{appState === 'ChatWindow' && (
				<>
					<BackToTopics onBackToTopics={() => setAppState('topicSelection')} />
					<ChatWindow selectedRisk={risk} selectedTopic={selectedTopic} />
				</>
			)}      
	  	</div>
    </div>
  );
};

export default App;
